/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PARSED_SHELF_DATA_FRAGMENT } from './ParsedShelfDataFragment'

export const PARSED_SEGMENT_DATA_FRAGMENT = gql`
  fragment ParsedSegmentData on ParsedSegmentData {
    segmentIndex
    shelves {
      ...ParsedShelfData
    }
  }
  ${PARSED_SHELF_DATA_FRAGMENT}
`
